import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import PlusCircle from "@insite/mobius/Icons/PlusCircle";
import { InputStyle } from "@insite/mobius/TextField";
import getColor from "@insite/mobius/utilities/getColor";
import { cartLineCardExpandedStyles as styles } from "@solveindustrial/Overrides/Widgets/Cart/CartLineCardExpanded";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.container = {
    ...styles.container,
    css: css`
        border: 1px solid ${getColor(colorStrings.commonBorder)};
        border-radius: 4px;
        padding: 16px;

        & + & {
            margin-top: 24px;
        }
    `,
};

styles.cartLineInfoContainer = {
    ...styles.cartLineInfoContainer,
    gap: 8,
};

styles.productInfoContainer = {
    ...styles.productInfoContainer,
    gap: 4,
};

styles.productBrand = {
    ...styles.productBrand,
    logoImage: {
        ...styles.productBrand?.logoImage,
        css: css`
            img {
                object-fit: contain;
            }
        `,
    },
};

styles.quantityAndExtendedUnitNetPriceContainer = {
    ...styles.quantityAndExtendedUnitNetPriceContainer,
    gap: 8,
};

styles.quantityGridItem = {
    ...styles.quantityGridItem,
    width: 3,
};

styles.quantity = {
    ...styles.quantity,
    editableQuantityTextField: {
        ...styles.quantity?.editableQuantityTextField,
        mergeCss: true,
        sizeVariant: "small",
        labelProps: {
            ...styles.quantity?.editableQuantityTextField?.labelProps,
            mergeCss: true,
            lineHeight: 1.8,
            transform: "none",
            css: css`
                ${styles.quantity?.editableQuantityTextField?.labelProps?.css}
                &&& {
                    font-size: 16px;
                    font-weight: 700;
                    text-transform: none;

                    ${mediaQueriesBP.maxMD} {
                        font-size: 14px;
                    }
                }
            `,
        },
        cssOverrides: {
            formInputWrapper: css`
                &&&& {
                    margin-top: 4px;

                    ${InputStyle} {
                        height: 30px;
                        min-height: 30px;

                        ${mediaQueriesBP.minMD} {
                            height: 30px;
                            min-height: 30px;
                        }
                    }
                }
            `,
        },
    },
};

styles.extendedUnitNetPriceGridItem = {
    ...styles.extendedUnitNetPriceGridItem,
    width: 9,
};

styles.totalLabelWrapper = {
    css: css`
        min-height: 30px;
        display: inline-flex;
        align-items: center;
    `,
};

styles.infoLabel = {
    weight: 700,
    size: "16px",
    lineHeight: 1.8,
    css: css`
        flex: 0 0 auto;

        ${mediaQueriesBP.maxMD} {
            font-size: 14px;
        }
    `,
};

styles.infoValue = {
    size: "16px",
    lineHeight: 1.8,
    css: css`
        flex: 1 1 auto;
        min-width: 0;
        ${wrapInContainerStyles}

        ${mediaQueriesBP.maxMD} {
            font-size: 14px;
        }
    `,
};

styles.addToListLink = {
    ...styles.addToListLink,
    icon: {
        iconProps: {
            src: PlusCircle,
            size: 18,
            color: colorStrings.commonPrimarySecond,
            css: css`
                margin-right: 4px;
            `,
        },
        position: "left",
    },
    css: css`
        margin-top: 8px;
    `,
};

styles.removeCartLineGridItem = {
    ...styles.removeCartLineGridItem,
    css: css`
        ${styles.removeCartLineGridItem?.css}

        justify-content: flex-end;
    `,
};

styles.removeCartLineIcon = {
    ...styles.removeCartLineIcon,
    size: 20,
    color: colorStrings.primaryMain,
};
